
export const MilestoneDetailDefaultData:any = {
    milestoneBasicDetail: {  _id:""},
    syllabus:             []
}

export interface MilestoneDetailData {
    milestoneBasicDetail: MilestoneBasicDetail;
    syllabus:             Syllabus[];
}

export interface MilestoneBasicDetail {
    _id:                    string;
    name:                   string;
    startDate:              string;
    endDate:                string;
    number:                 number;
    Duration:               string;
    totalAssignment:        number;
    contentTypes:           ContentTypes;
    chapterCount:           number;
    chapters:               MilestoneBasicDetailChapter[];
    selectedMilestoneIndex: number;
}

export interface MilestoneBasicDetailChapter {
    chapterId: string;
    _id:       string;
    content:   any[];
}

export interface ContentTypes {
}

export interface Syllabus {
    _id:           string;
    subjects:      Subsubject[];
    class:         string;
    milestoneTest: MilestoneTest[];
}

export interface MilestoneTest {
    testId: string;
    _id:    string;
}

export interface Subsubject {
    _id:          string;
    name:         string;
    type:         string;
    subSubjects?: Subsubject[];
    chapters?:    SubjectChapter[];
}

export interface SubjectChapter {
    _id:             string;
    name:            string;
    type:            string;
    conceptCount:    number;
    assignmentCount: number;
}
